import { render } from "./AdminShowIndex.vue?vue&type=template&id=5abe91e8"
import script from "./AdminShowIndex.vue?vue&type=script&lang=js"
export * from "./AdminShowIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__